import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GetOrderDetails, GetAddress } from "../Data";
import AddressBookAR from "./AddressBook/AddressBookAR";
import OrderDetailsAR from "./Orders/OrderDetailsAR";
import Utils from "../../Classes/Utils";
import { Global } from "../Variables/Global";
import Cookies from "js-cookie";

const AccountAR = () => {
  const [showActive, setShowActive] = useState("Orders");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [modalData, setModalData] = useState(null);
  const [show, setShow] = useState(false);
  const [orders, setOrders] = useState([]);
  const [addressBook, setAddressBook] = useState({});
  const navigate = useNavigate();
  const token = Cookies.get("CustomerToken");

  const HandleLogout = () => {
    Cookies.remove("CustomerToken",{
      expires: new Date(),
      path: '/'
    });
    Cookies.remove("User");
    Cookies.remove("WishList");
    Cookies.remove("Cart");
    Cookies.remove("Subscribe");
    Cookies.remove("Number");
    navigate("/AR/Authentication");
  };

  const GetAddressBookDetails = () => {
    // const getItem = Cookies.get("Number") !== undefined;
    if (Cookies.get("Number") !== undefined) {
      var CustomerId = Cookies.get("Number");
      GetAddress(CustomerId,token).then((res) => {
        setAddressBook(res);
        if (res?.CityId) {
            fetch(Global.API_URL + "Country/GetCitiyNameById/" + res.CityId, {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Authorization:": `Bearer ${token}`,
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": Global.API_URL,
              },
            })
              .then((response) => {
                return response.json();
              })
              .then((Result) => {
                setCity(Result[0].CityName);
                if (Result[0].CountryCode === "UAE") {
                  setCountry("United Arab Emirates");
                } else if (Result[0].CountryCode === "LB") {
                  setCountry("Lebanon");
                }
              });
          }
      });
    }
  };
  const GetOrderDetailsByCustomerId = () => {
    const getItem = Cookies.get("Number") !== undefined;

    if (Cookies.get("Number") !== undefined) {
      const id = Cookies.get("Number");
      GetOrderDetails(id,token).then((result) => {
        setOrders(result);
      });
    }
  };

  useEffect(() => {
    if(Cookies.get("CustomerToken") === undefined){
      navigate("/AR/Authentication");
    }
    // getCustomerInfo();
    GetOrderDetailsByCustomerId();
    GetAddressBookDetails();
  }, []);
  return (
    <>
      <div className="breadcrumb-area mb-5 ">
        <div className="container ">
          <div className="row ">
            <div className="col ">
              <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                <div className="breadcrumbArabic HomeShop">
                  <ul>
                    <li className="active">حسابي</li>
                    <li>
                      <a style={{ direction: "rtl" }} href="index.html">
                        <i className="fa fa-home"></i>
                        المنزل
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-account-section section position-relative mb-5 fix">
        <div className="container">
          <div className="row directionRtl">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-3 col-12">
                  <div className="myaccount-tab-menu nav" role="tablist">
                    <a
                      href="#orders"
                      data-bs-toggle="tab"
                      className="RemUnderline active"
                      onClick={() => setShowActive("Orders")}
                    >
                      <i className="fa fa-cart-arrow-down"></i> الطلبات
                    </a>

                    <a
                      href="#address-edit"
                      data-bs-toggle="tab"
                      className="RemUnderline"
                      onClick={() => setShowActive("Address")}
                    >
                      <i className="fa fa-map-marker"></i> العنوان
                    </a>

                    <a
                      href="#account-info"
                      data-bs-toggle="tab"
                      className="RemUnderline"
                      onClick={() => setShowActive("account-info")}
                    >
                      <i className="fa fa-user"></i>عنوان الشحن
                    </a>

                    <a className="RemUnderline" onClick={HandleLogout}>
                      <i className="fa fa-sign-out"></i>تسجيل الخروج
                    </a>
                  </div>
                </div>
                <div className="col-lg-9 col-12">
                  <div className="tab-content" id="myaccountContent">
                    <div
                      className={`tab-pane fade ${
                        showActive.includes("Orders") ? "show active" : ""
                      } `}
                      id="orders"
                      role="tabpanel"
                    >
                      {/* ---------------- Orders ---------------- */}
                {showActive === "Orders" && (
                  <div className="myaccount-content">
                    <h3 className="mb-4">طلباتي</h3>

                    {orders.length > 0 ? (
                      <div className="row">
                        {orders.map((order, index) => (
                          <div key={index} className="col-12 mb-3">
                            <div className="card shadow-sm border-0">
                              <div className="card-body">

                                <div className="d-flex justify-content-between mb-2">
                                  <div>
                                    <h6 className="mb-0">
                                      طلب #{order.OrderNumber || order.OrderId}
                                    </h6>
                                    <small className="text-muted">
                                      {new Date(order.Date).toLocaleString()}
                                    </small>
                                  </div>

                                  <span className={`badge ${
                                    order.OrderStatusName === "Completed"
                                      ? "bg-success"
                                      : order.OrderStatusName === "Pending"
                                      ? "bg-warning"
                                      : "bg-secondary"
                                  }`}>
                                    {order.OrderStatusName}
                                  </span>
                                </div>

                                <div className="row mt-3">
                                  <div className="col-md-4">
                                    <b>الإجمالي:</b> {order.Currency} {order.OrderTotal}
                                  </div>
                                  <div className="col-md-4">
                                    <b>الدفع:</b> {order.PaymentMethodName}
                                  </div>
                                  <div className="col-md-4 text-md-end">
                                    <button
                                      className="btn btn-sm"
                                      style={{
                                        borderColor: "#115938",
                                        color: "#115938",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#115938";
                                        e.currentTarget.style.color = "#fff";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "transparent";
                                        e.currentTarget.style.color = "#115938";
                                      }}
                                      onClick={() => {
                                        setModalData(order);
                                        setShow(true);
                                      }}
                                    >
                                      عرض التفاصيل
                                    </button>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <h4>لا توجد طلبات بعد</h4>
                    )}

                    {show && (
                      <OrderDetailsAR
                        modalData={modalData}
                        show={show}
                        setShow={setShow}
                      />
                    )}
                  </div>
                )}
                    </div>
                    <div
                      className="tab-pane fade"
                      id="download"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>Downloads</h3>

                        <div className="myaccount-table table-responsive text-center">
                          <table className="table table-bordered">
                            <thead className="thead-light">
                              <tr>
                                <th>Product</th>
                                <th>Date</th>
                                <th>Expire</th>
                                <th>Download</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>Mostarizing Oil</td>
                                <td>Aug 22, 2022</td>
                                <td>Yes</td>
                                <td>
                                  <a href="#" className="btn">
                                    Download File
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td>Katopeno Altuni</td>
                                <td>Sep 12, 2022</td>
                                <td>Never</td>
                                <td>
                                  <a href="#" className="btn">
                                    Download File
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="payment-method"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>Payment Method</h3>

                        <p className="saved-message">
                          You Can't Saved Your Payment Method yet.
                        </p>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="address-edit"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>عنوان إرسال الفواتير</h3>

                        {addressBook ? (
                          <address>
                            <p>
                              <strong>
                                {addressBook.FirstName +
                                  " " +
                                  addressBook.LastName}
                              </strong>
                            </p>
                            <p>{country}</p>
                            <p>{city}</p>
                            <p>{addressBook.Address1}</p>
                            <p>{addressBook.Address2}</p>
                            <p>رقم الهاتف: {addressBook.PhoneNumber}</p>
                          </address>
                        ) : (
                          <h3>لا يوجد عنوان الفواتير</h3>
                        )}

                        {/* <a href="#" className="btn d-inline-block edit-address-btn"><i className="fa fa-edit"></i>تعديل العنوان</a> */}
                      </div>
                    </div>
                    <div
                      className={`tab-pane fade ${
                        showActive.includes("account-info") ? "show active" : ""
                      } `}
                      id="account-info"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>عنوان الشحن</h3>

                        <div className="account-details-form">
                          <AddressBookAR />
                          {/* <form action="#">
                                                        <div className="row">
                                                            <div className="col-lg-6 col-12 mb-3">
                                                                <input id="first-name" placeholder="الإسم الأول" type="text" />
                                                            </div>

                                                            <div className="col-lg-6 col-12 mb-3">
                                                                <input id="last-name" placeholder="إسم العائلة" type="text" />
                                                            </div>

                                                            <div className="col-12 mb-3">
                                                                <input id="display-name" placeholder="اسم العرض" type="text" />
                                                            </div>

                                                            <div className="col-12 mb-3">
                                                                <input id="email" placeholder="البريد الإلكتروني" type="email" />
                                                            </div>

                                                            <div className="col-12 mb-3">
                                                                <h4>تغيير كلمة المرور</h4>
                                                            </div>

                                                            <div className="col-12 mb-3">
                                                                <input id="current-pwd" placeholder="كلمة المرور الحالية" type="password" />
                                                            </div>

                                                            <div className="col-lg-6 col-12 mb-3">
                                                                <input id="new-pwd" placeholder="كلمة مرور جديدة" type="password" />
                                                            </div>

                                                            <div className="col-lg-6 col-12 mb-3">
                                                                <input id="confirm-pwd" placeholder="تأكيد كلمة المرور الجديدة" type="password" />
                                                            </div>

                                                            <div className="col-12">
                                                                <button className="save-change-btn">حفظ التغييرات</button>
                                                            </div>

                                                        </div>
                                                    </form> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountAR;
